import classNames from "classnames";

import CommonHero from "components/commonHero/commonHero";
import { LeaderboardsPageData } from "lib/types/leaderboards";
import { findLatestPublishDateId, sortData } from "./lib";
import { ListView } from "./components/list/listView";
import { LeaderboardCard } from "./components/leaderboardCard/leaderboardCard";

const innerContainerClasses = classNames(
  "mx-auto w-100 max-w-[1040px] px-5 lg:max-w-[1220px] lg:px-0"
);

type LeaderboardsViewProps = {
  data: LeaderboardsPageData;
};

const LeaderboardsView = ({ data }: LeaderboardsViewProps) => {
  const latestId = findLatestPublishDateId([
    ...data.latestSectionLeaderboards,
    ...data.leaderboards,
  ]);

  return (
    <>
      <main className="content-spacing w-100 overflow-x-hidden bg-[#F4F4F6] text-black-rock">
        <div className="relative">
          <CommonHero
            title={data.heroTitle}
            brandColor={"cerise"}
            subtitle={data.heroSubtitle}
          />
          <div className={classNames(innerContainerClasses)}>
            <div className="mb-[50px] mt-[42px] grid grid-cols-1 gap-y-[14px] md:mb-[70px] md:mt-[44px] md:grid-cols-2 md:gap-x-5 md:gap-y-5 lg:mt-[55px] lg:grid-cols-3 lg:gap-x-[44px]">
              <div className="flex flex-col">
                <p className="font-recklessBold text-[32px] text-mono-40 md:col-span-2 lg:col-span-1">
                  {data.latestSectionHeading}
                </p>
                {data.latestSectionSubHeading && (
                  <p className="font-serif text-base leading-xl text-black">
                    {data.latestSectionSubHeading}
                  </p>
                )}
              </div>
              {sortData(data.latestSectionLeaderboards, "latest")
                .slice(0, 2)
                .map((leaderboard) => {
                  return (
                    <div key={leaderboard.id} className="min-h-[435px] w-100">
                      <LeaderboardCard
                        leaderboard={leaderboard}
                        latestId={latestId}
                      />
                    </div>
                  );
                })}
            </div>

            <div className="relative left-50 right-50 ml-[-50vw] mr-[-50vw] w-[100vw] bg-[#EBEBED] pt-[70px]">
              <div className={classNames(innerContainerClasses, "pb-[100px]")}>
                <ListView data={data} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default LeaderboardsView;
